import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState } from './common';
import { IProcess } from '../interfaces/process';
import { sendError } from '../sendError';

const name = 'clientProcesses';

type FetchClientProcesses = {
  organizationId: string;
  token?: string;
};

export const fetchClientProcesses = createAsyncThunk(
  `${name}/fetchClientProcesses`,
  async ({ organizationId, token }: FetchClientProcesses) => {
    const headers: Record<string, string> = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const { data } = await axios.get<{ value: IProcess[]; '@odata.count': number }>(
      `/api/processautomation/v1.0/organizations/${organizationId}/automations`,
      { headers }
    );

    return { data: data.value, total: data['@odata.count'] };
  }
);

export type State = CommonState & {
  clientProcesses: IProcess[] | null;
  total: number;
};

const initialState: State = {
  error: null,
  isFetching: false,
  clientProcesses: null,
  total: 0
};

const clientProcesses = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchClientProcesses.pending, state => {
      state.isFetching = true;
      state.error = null;
    });
    builder.addCase(fetchClientProcesses.fulfilled, (state, action) => {
      state.clientProcesses = action.payload.data;
      state.total = action.payload.total;
      state.isFetching = false;
    });
    builder.addCase(fetchClientProcesses.rejected, (state, action) => {
      state.isFetching = false;
      sendError(action.error);
    });
  }
});

export const { reducer: clientProcessesReducer } = clientProcesses;
